import createSortList from "src/decidim/admin/sort_list.component";
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-draggable-table]").forEach((container) => {
    const options = {
      forcePlaceholderSize: true,
      onSortUpdate: ($children) => {
        const children = $children.toArray();
        if (children.length === 0) {
          return;
        }
        const parent = children[0].parentNode;
        const sortUrl = parent.dataset.sortUrl;
        const order = children.map((child) => child.dataset.recordId);
        if (sortUrl && sortUrl !== "#") {
          $.ajax({
            method: "PUT",
            url: sortUrl,
            contentType: "application/json",
            data: JSON.stringify({ order_ids: order })
            // eslint-disable-line camelcase
          });
        }
      }
    };
    if (container.dataset.draggableHandle) {
      options.handle = container.dataset.draggableHandle;
    }
    if (container.dataset.draggablePlaceholder) {
      options.placeholder = container.dataset.draggablePlaceholder;
    }
    createSortList(container, options);
  });
});
